import { IJsonApi, IJsonApiBase, IJsonApiData, IJsonApiIncludedHash } from "./types";

/**
 * Helper function to serialize a standard JSON:API data structure.
 * Does NOT support cyclic relationships
 * For meta data, it can be extracted directly from the DTO without the adapter
 * @param jsonApiDTO
 * @returns
 */
export const jsonApiAdapter = <A, T, M = unknown>(jsonApiDTO: IJsonApi<A, T, M>) => {
	if (!jsonApiDTO) return null;
	const { included, data } = jsonApiDTO;
	const includedHash = getIncludedHash(included);

	if (Array.isArray(data)) {
		return data.map((single) => processIncludedRelationships(single, includedHash));
	}

	return processIncludedRelationships(data, includedHash);
};

const getHash = ({ id, type }: IJsonApiBase): string => `[${type}]::[${id}]`;

const getIncludedHash = <T>(included?: IJsonApiData<T>[]): IJsonApiIncludedHash<T> => {
	if (!included) return {};

	return included.reduce<IJsonApiIncludedHash<T>>((hash, include) => {
		hash[getHash(include)] = include;

		return hash;
	}, {});
};

const processIncludedRelationships = <A, T>(
	data: IJsonApiData<A>,
	included: IJsonApiIncludedHash<T>
) => {
	const { id, type, attributes, relationships } = data;
	const resultData = { id, type, ...attributes };

	if (relationships) {
		for (const key of Object.keys(relationships)) {
			const rdata = relationships[key]!.data;

			if (rdata) {
				if (Array.isArray(rdata)) {
					// @ts-ignore
					resultData[key] = rdata.map((rel) => findIncludedTypeId(included, rel));
				} else {
					// @ts-ignore
					resultData[key] = findIncludedTypeId(included, rdata);
				}
			}
		}
	}

	return resultData;
};

const findIncludedTypeId = <T>(included: IJsonApiIncludedHash<T>, relationship: IJsonApiBase) => {
	const data = included[getHash(relationship)];

	return processIncludedRelationships(data, included);
};
